import { SUBTITLE_SIZE } from '@app/core/cms-flex/types';

import { SubtitleSize } from '../types';

export const SUB_TITLE_SIZE = new Map<SUBTITLE_SIZE, SubtitleSize>()
  .set(SUBTITLE_SIZE.SMALL, 'content-subtitle__small')
  .set(SUBTITLE_SIZE.MEDIUM, 'content-subtitle__medium')
  .set(SUBTITLE_SIZE.LARGE, 'content-subtitle__large');
